import {Component, Input} from '@angular/core';
import {AppState} from "../../store/store";
import {Store} from "@ngrx/store";
import {Observable} from "rxjs";
import {Serializer} from "../../interfaces/serializer";
import {User} from "../../interfaces/user";
import {selectProfile} from "../../store/profile/profile.selectors";
import {changeRealConversionsCorrectionMode} from "../../store/profile/profile.actions";

@Component({
  selector: 'app-real-conversions-menu',
  templateUrl: './real-conversions-menu.component.html',
  styleUrls: ['./real-conversions-menu.component.scss']
})
export class RealConversionsMenuComponent {
  @Input() public disabled: boolean;

  protected _profile$: Observable<Serializer<User>> = this._store.select(selectProfile);
  private realConversionsModes = [
    {
      level: 0,
      label: 'real_conversions.disabled',
      color: 'red'
    },
    {
      level: 1,
      label: 'real_conversions.post_click_correction',
      color: 'yellow'
    },
    {
      level: 2,
      label: 'real_conversions.post_view_correction',
      color: 'green'
    },
    {
      level: 3,
      label: 'real_conversions.post_click_view_correction_status',
      color: 'green'
    }
  ];

  constructor(
    private readonly _store: Store<AppState>
  ) {
  }

  public setRealConversions(mode: number): void {
    this._store.dispatch(changeRealConversionsCorrectionMode({mode: mode}));
  }

  public modeTo(elem: string, mode: number): string {
    const foundMode = this.realConversionsModes.find(real_conversions_mode => real_conversions_mode['level'] === mode);
    return foundMode[elem];
  }
}
